module.exports = __webpack_public_path__ + "img/engineering_2.467dd369.jpg";